import { ASSET_PATHS } from "../../../../core/constants/asset-paths";
import { appPath } from "../../../../core/utilities/app-base-path";
import { DialogHeaderIcon } from "../../overlay/dialog/models/dialog-header-icon.model";

import { ResolvedIconRef } from "./models/icon.model";

export const ICONS_SPRITE_PATH = ASSET_PATHS.icons.sprite;

export const GENERAL_ICONS_SPRITE_PATH = ICONS_SPRITE_PATH;

export const DIALOG_ICONS_SPRITE_PATH = ICONS_SPRITE_PATH;

const DIALOG_ICON_IDS = new Set<string>(Object.values(DialogHeaderIcon));

export const ICON_ALIASES: Record<string, string> = {
	clear: "close-icon",
	dismiss: "close-icon",
	close: "close-icon",
	"bars-3": "bars-3",
	burger: "bars-3",
	bell: "notification-01",
	requests: "requests",
	sort: "sort_by",
	"settlement-clock": "settlement-clock",
	notifications: "notification-01",
	notification: "notification-01",
	"notify-circle": "notification-01",
	message: "chat",
	chatbot: "chatbot",
	"chat-bot": "chatbot",
	"account-requests": "requests",
	"transaction-lifespan": "statistics",
	"transaction-lifespan-summary": "statistics",
	"information-circle": "info",
	users: "beneficiaries",
	roles: "departments-roles-icon",
	notices: "notices-icon",
	notes: "notices-icon",
	reports: "reports",
	complaints: "complaints-document-icon",
	complaint: "complaints-document-icon",
	"professional-monitoring": "professional-monitoring-icon",
	faq: "faq-icon",
	faqs: "faq-icon",
	help: "faq-icon",
	contact: "contact-us-icon",
	"contact-us": "contact-us-icon",
	workflow: "requests",
	"login-01": "login",
	"login__el-1": "login",
	danger: "close-icon",
	submit: "check-circle-icon",
	format: "sort_by",
	mask: "eye-view",
	viewport: "eye-view",
	icon: "info-circle",
	"collapse-sidebar": "collapse-sidebar",
	"expand-sidebar": "expand-sidebar",
	history: "history",
	"audit-log": "history",
	"audit-log-transactions": "audit-log-transactions",
	"audit-log-general": "audit-log-general",
	"table-arrow-left": "table-arrow-left",
	"paginator-prev": "paginator-prev",
	"paginator-next": "paginator-next",
	export_excel: "export_excel",
	"file-upload": "file-upload",
	"page-back-arrow": "back-button-arrow",
	"profile-logout": "logout-icon",
	check: "check-icon",
	"check-wizard": "check-wizard",
	success: "success-check",
	"success-circle": "success-check",
	"success-check": "success-check",
	"list-check": "check-icon",
	"about-feature-check": "check-icon",
	"how-it-works-check": "how-it-works-check",
	"services-feature-check": "services-feature-check",
	search: "search-icon",
	"search-stroke": "search-stroke",
	"add-plus-circle-icon": "add-plus-circle-icon",
	"add-plus-circle-white": "add-plus-circle-white",
	"add-circle-icon": "add-circle-icon",
	"back-arrow-icon": "back-arrow-icon",
	"check-circle-icon": "check-circle-icon",
	"chevron-right-sm": "chevron-right-sm",
	"chevron-select": "chevron-dropdown",
	"info-circle": "info-circle",
	"status-card-info-gray": "status-card-info-gray",
	"status-card-info-blue": "status-card-info-blue",
	"status-card-danger": "status-card-danger",
	"status-card-warning": "status-card-warning",
	"status-card-success": "status-card-success",
	copy: "copy",
	"theme-sun": "weather-clear",
	"theme-moon": "theme-moon",
};

export function isDialogIcon(name: string): boolean {
	return DIALOG_ICON_IDS.has(name?.trim() ?? "");
}

export function resolveSymbolId(name: string): string {
	const trimmed = name?.trim() ?? "";
	if (!trimmed) {
		return "";
	}

	let current = trimmed;
	const seen = new Set<string>();
	while (ICON_ALIASES[current] && !seen.has(current)) {
		seen.add(current);
		current = ICON_ALIASES[current]!;
	}

	return current;
}

export function resolveIconRef(name: string): ResolvedIconRef {
	const symbolId = resolveSymbolId(name);

	return { sprite: appPath(ICONS_SPRITE_PATH), symbolId };
}

export function resolveIconHref(name: string, inlined = false): string {
	const { sprite, symbolId } = resolveIconRef(name);
	if (!symbolId) {
		return "";
	}

	return inlined ? `#${symbolId}` : `${sprite}#${symbolId}`;
}
